import { html, property } from 'lit-element';
import { cssResult } from '../../util/css.js';
import { addListener, stopEvent } from '../../util/event.js';
import { ENTER, SPACE } from '../../util/constant/keycode.js';
import { __decorate, __metadata } from 'tslib';
import '../../ripple/ripple.js';
import { ifDefined } from 'lit-html/directives/if-defined';
import { FormElementBehavior } from '../form-element/form-element-behavior.js';
import '../form-element/index.js';
import styles from './button-behavior.scss.js';

class ButtonBehavior extends FormElementBehavior {
    constructor() {
        super(...arguments);
        this.type = 'submit';
    }
    connectedCallback() {
        super.connectedCallback();
        this.listeners.push(addListener(this, 'click', this.onClick.bind(this)), addListener(this, 'keydown', this.onKeyDown.bind(this)));
    }
    onKeyDown(e) {
        if (e.code === ENTER || e.code === SPACE) {
            this.click();
            stopEvent(e);
            if (this.$ripple != null) {
                this.$ripple.spawnRipple(undefined, { autoRelease: true });
            }
        }
    }
    onClick(e) {
        if (this.disabled) {
            stopEvent(e);
            return;
        }
        if (e.target == this && !e.defaultPrevented) {
            this.$formElement.dispatchEvent(new MouseEvent('click', {
                relatedTarget: this,
                composed: true
            }));
        }
    }
    renderFormElement() {
        return html` <button style="display: none;" id="${this.formElementId}" aria-hidden="true" tabindex="-1" type="${this.type}" ?disabled="${this.disabled}" name="${ifDefined(this.name)}" value="${ifDefined(this.value)}"> </button> `;
    }
}
ButtonBehavior.styles = [
    ...FormElementBehavior.styles,
    cssResult(styles)
];
__decorate([
    property({ type: String }),
    __metadata('design:type', String)
], ButtonBehavior.prototype, 'type', void 0);

export { ButtonBehavior };
